import { PROCESSING_STAGES } from '../constants/processing-stages';
import type { ProcessingStage } from '../types/processing-stage';
import type { ProcessingStageId } from '../types/processing-stage-id';

/**
 * True when `next` should replace `current` on the checklist.
 * Stages outside `stages` always pass: they have no rank.
 */
export function isLaterProcessingStage(
  next: ProcessingStageId,
  current: ProcessingStageId | undefined,
  stages: readonly ProcessingStage[] = PROCESSING_STAGES
): boolean {
  if (current === undefined) return true;
  const nextIndex = stages.findIndex(stage => stage.id === next);
  const currentIndex = stages.findIndex(stage => stage.id === current);
  if (nextIndex < 0 || currentIndex < 0) return true;
  return nextIndex > currentIndex;
}
